import { Sparkle, X } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import type { AiInsight } from "./types";

interface Props {
  insight: AiInsight;
  dismissLabel: string;
}

export function AiInsightCard({ insight, dismissLabel }: Props) {
  return (
    <div
      role="region"
      aria-label={insight.title}
      className={cn(
        "relative rounded-biz-card border p-4",
        "bg-gradient-to-br from-biz-accent-subtle/60 to-biz-primary-subtle/40",
        "border-biz-accent/20",
      )}
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 shrink-0 rounded-biz-btn bg-biz-accent text-biz-accent-foreground flex items-center justify-center">
          {insight.icon ?? <Sparkle size={16} weight="regular" />}
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-sm font-display font-semibold text-biz-foreground">{insight.title}</div>
          <p className="mt-0.5 text-sm text-biz-foreground-muted leading-relaxed">{insight.body}</p>
          {insight.actions && insight.actions.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {insight.actions.map((a) => (
                <button
                  key={a.label}
                  type="button"
                  onClick={a.onClick}
                  className="h-9 px-3 rounded-biz-btn bg-biz-surface border border-biz-border text-sm font-semibold text-biz-foreground hover:bg-biz-muted biz-focus-ring transition-colors"
                >
                  {a.label}
                </button>
              ))}
            </div>
          )}
        </div>
        {insight.onDismiss && (
          <button
            type="button"
            onClick={insight.onDismiss}
            aria-label={dismissLabel}
            className="h-9 w-9 -mt-1 -mr-1 inline-flex items-center justify-center rounded-biz-btn text-biz-foreground-muted hover:bg-biz-muted biz-focus-ring"
          >
            <X size={16} weight="regular" />
          </button>
        )}
      </div>
    </div>
  );
}
